import React, { Component } from 'react';

class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleFormSubmit = async (e) => {
        e.preventDefault();
        
        const form = e.currentTarget;
        const submitButton = form.querySelector('input[type="submit"]');
        const messageDiv = document.getElementById('message');
        const simpleMsgDiv = document.getElementById('simple-msg');
        
        // Disable submit button and show loading state
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.value = 'Sending...';
        }

        try {
            // Convert form data to URL-encoded format
            const formData = new FormData(form);
            const urlEncodedData = new URLSearchParams();
            
            for (const [key, value] of formData.entries()) {
                urlEncodedData.append(key, value);
            }

            const response = await fetch('https://formspree.io/f/mnqgoepp', {
                method: 'POST',
                body: urlEncodedData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                const result = await response.json();
                // Show success message
                if (messageDiv) {
                    messageDiv.innerHTML = '<div class="alert alert-success">Thank you! Your message has been sent successfully.</div>';
                }
                if (simpleMsgDiv) {
                    simpleMsgDiv.innerHTML = '<div class="alert alert-success">Thank you! Your message has been sent successfully.</div>';
                }
                // Reset form
                form.reset();
                // Close modal after a short delay (if it's in a modal)
                setTimeout(() => {
                    // Check if we're in a modal context
                    const modal = form.closest('.modal');
                    if (modal) {
                        const closeButton = modal.querySelector('[data-dismiss="modal"]');
                        if (closeButton) {
                            closeButton.click();
                        }
                    }
                }, 2000);
            } else {
                const error = await response.json();
                throw new Error(error.message || 'Form submission failed');
            }
        } catch (error) {
            // Show error message
            if (messageDiv) {
                messageDiv.innerHTML = '<div class="alert alert-danger">Sorry, there was an error sending your message. Please try again.</div>';
            }
            if (simpleMsgDiv) {
                simpleMsgDiv.innerHTML = '<div class="alert alert-danger">Sorry, there was an error sending your message. Please try again.</div>';
            }
        } finally {
            // Re-enable submit button
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.value = 'Send Message';
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <section className="contact" id="contact">
                    <div className="modal fade" id="ModalCenter" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Get in touch</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className="custom-form">
                                        <div id="message"></div>
                                        <form onSubmit={this.handleFormSubmit} name="contact-form" id="contact-form">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-4">
                                                        <input name="name" id="name" type="text" className="form-control" placeholder="Your Name..." required />
                                                    </div>
                                                    <div className="form-group mb-4">
                                                        <input name="_replyto" id="email" type="email" className="form-control" placeholder="Your Email..." required />
                                                    </div>
                                                    <div className="form-group mb-4">
                                                        <input name="subject" id="subject" type="text" className="form-control" placeholder="Your Subject..." />
                                                    </div>
                                                    <div className="form-group">
                                                        <textarea name="message" id="message" rows="4" className="form-control" placeholder="Your Message..." required></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-sm-12 text-right">
                                                    <input type="submit" id="submit" name="send" className="submitBnt btn btn-custom" value="Send Message" />
                                                    <div id="simple-msg"></div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment >
        );
    }
}

export default Contact;


